import { Button, Grid, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomCircularProgress from "../../components/CustomCircularProgress";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(10),
    },
    info: {
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(2),
        boxShadow: '1px 2px 2px 2px ' + theme.palette.background.card,
    },
    header: {
        textAlign: 'center',
        padding: theme.spacing(2),
        borderBottom: '1px solid ' + theme.palette.background.card,
    },
    payment_info: {
        padding: theme.spacing(2),
        textAlign: 'center',
        borderBottom: '1px solid ' + theme.palette.background.card,
    },
    footer: {
        padding: theme.spacing(2),
        // marginTop: theme.spacing(4),
    },
    button: {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    infoItemLeft: {
        textAlign: 'right',
    },
    infoItemRight: {
        textAlign: 'left',
    },
}));

export default function PaymentLinkView(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    const { paymentInfo, onLogin, onContinuePayment, onCancelOrder, currency, showLoading } = props;
    let contactName = '';
    if (paymentInfo && paymentInfo.first_name) {
        contactName += paymentInfo.first_name;
    }
    if (paymentInfo && paymentInfo.last_name) {
        contactName += ' ' + paymentInfo.last_name;
    }
    return (
        <Grid item xs={12} container justifyContent={"center"} className={classes.container}>
            {showLoading && <CustomCircularProgress /> }
            {!showLoading && <Grid item xs={12} md={8} lg={6} className={classes.info}>
                {paymentInfo && paymentInfo.crm_order_id ? <Grid item xs={12}>
                    {paymentInfo && paymentInfo.status == 'PAID' ? <Grid item xs={12} container justifyContent={"center"}>
                        <Typography>{t('payment_info_paid_message')}</Typography>
                        <Grid item xs={12}>
                            <Button color="primary" onClick={() => onLogin()}>{t('btn_login')}</Button>
                        </Grid>
                    </Grid> : <Grid item xs={12} container justifyContent={"center"}>
                        <Grid item xs={12} className={classes.header}>
                            <Grid item style={{ marginBottom: 8 }}>
                                <Typography variant="h6">{t('Hi ')} {contactName}{t(', welcome back!')}</Typography>
                            </Grid>
                            <Grid item>
                                <Typography variant="body1">{t('Here is the detailed information about your account and product.')}</Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={'center'} className={classes.payment_info}>
                            <Grid item xs={12}>
                                <Grid item xs={12} container spacing={1} alignItems="center">
                                    {/* <Grid item xs={6} className={classes.infoItemLeft}>
                                        <Grid item xs={12}><Typography>{t('Product')}: </Typography></Grid>
                                        <Grid item xs={12}><Typography>{t('Contact Code')}: </Typography></Grid>
                                        <Grid item xs={12}><Typography>{t('Email')}: </Typography></Grid>
                                        <Grid item xs={12}><Typography>{t('Location Ref')}: </Typography></Grid>
                                        <Grid item xs={12}><Typography>{t('Amount')}: </Typography></Grid>
                                    </Grid>
                                    <Grid item xs={6} className={classes.infoItemRight}>
                                        <Grid item xs={12}><Typography variant="body2">{paymentInfo.product_code}</Typography></Grid>
                                        <Grid item xs={12}><Typography variant="body2">{paymentInfo.contact_code}</Typography></Grid>
                                        <Grid item xs={12}><Typography variant="body2">{paymentInfo.email_address}</Typography></Grid>
                                        <Grid item xs={12}><Typography variant="body2">{paymentInfo.location_id ? paymentInfo.location_id : <span>&nbsp;</span>}</Typography></Grid>
                                        <Grid item xs={12}><Typography variant="body2">{currency}{paymentInfo.order_amount ? paymentInfo.order_amount.toFixed(2) : "0.00"}</Typography></Grid>
                                    </Grid> */}
                                    <Grid item xs={12} container spacing={1} alignItems='center'>
                                        <Grid item xs={6} container justifyContent={'flex-end'}>
                                            <Typography>{t('Product')}: </Typography>
                                        </Grid>
                                        <Grid item xs={6} container justifyContent={'flex-start'}>
                                            <Typography variant="body2">{paymentInfo.product_code}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container spacing={1} alignItems='center'>
                                        <Grid item xs={6} container justifyContent={'flex-end'}>
                                            <Typography>{t('Contact Code')}: </Typography>
                                        </Grid>
                                        <Grid item xs={6} container justifyContent={'flex-start'}>
                                            <Typography variant="body2">{paymentInfo.contact_code}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container spacing={1} alignItems='center'>
                                        <Grid item xs={6} container justifyContent={'flex-end'}>
                                            <Typography>{t('Email')}: </Typography>
                                        </Grid>
                                        <Grid item xs={6} container justifyContent={'flex-start'}>
                                            <Typography variant="body2">{paymentInfo.email_address}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container spacing={1} alignItems='center'>
                                        <Grid item xs={6} container justifyContent={'flex-end'}>
                                            <Typography>{t('Location Ref')}: </Typography>
                                        </Grid>
                                        <Grid item xs={6} container justifyContent={'flex-start'}>
                                            <Typography variant="body2">{paymentInfo.location_id ? paymentInfo.location_id : <span>&nbsp;</span>}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container spacing={1} alignItems='center'>
                                        <Grid item xs={6} container justifyContent={'flex-end'}>
                                            <Typography>{t('Amount')}: </Typography>
                                        </Grid>
                                        <Grid item xs={6} container justifyContent={'flex-start'}>
                                            <Typography variant="body2">{currency}{paymentInfo.order_amount ? paymentInfo.order_amount.toFixed(2) : "0.00"}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} container justifyContent={'center'} className={classes.footer}>
                            <Button variant="contained" color="primary" onClick={() => onContinuePayment()} className={classes.button}>{t('btn_continue_payment')}</Button>
                            <Button variant="contained" color="primary" onClick={() => onCancelOrder()} className={classes.button}>{t('btn_cancel_order')}</Button>
                        </Grid>
                    </Grid>}
                </Grid> : <Grid item xs={12} container justifyContent={'center'}>
                    <Typography>{t('PAYMENT_LINK_NOT_FOUND')}</Typography>
                    <Grid item xs={12} container justifyContent={'center'} style={{marginTop: 16}}>
                        <Button variant="contained" color="primary" onClick={() => onLogin()}>{t('Back To Login')}</Button>
                    </Grid>
                </Grid>}
            </Grid>}
        </Grid>
    );
}